import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  focus: defineAsyncComponent(() => import("/app/layouts/focus.vue").then(m => m.default || m)),
  full: defineAsyncComponent(() => import("/app/layouts/full.vue").then(m => m.default || m))
}